import { useEffect, useState } from 'react';
import type { AvailabilitiesViewMode } from './components/AvailabilitiesViewToggle';

const STORAGE_KEY = 'public_availabilities_view_mode';

export function useAvailabilitiesViewMode(): [
  AvailabilitiesViewMode,
  (next: AvailabilitiesViewMode) => void,
] {
  const [viewMode, setViewMode] = useState<AvailabilitiesViewMode>(() => {
    if (typeof window === 'undefined') {
      return 'cards';
    }
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'map' || stored === 'cards' ? stored : 'cards';
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, viewMode);
  }, [viewMode]);

  return [viewMode, setViewMode];
}
